import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

/**
 * Convenience hook that destructures AuthContext.
 * Throws if used outside of <AuthProvider> — makes forgotten providers visible in dev.
 */
export function useAuth() {
  const ctx = useContext(AuthContext);
  if (ctx === null) {
    throw new Error('useAuth() must be used inside <AuthProvider>');
  }
  return ctx;
}
